// extracted by mini-css-extract-plugin
module.exports = {"pair":"PeriodOfExecution_pair__2Ka_H","centered":"PeriodOfExecution_centered__3wQaT"};